import { ReactNode } from 'react';
import { FlexRow } from 'components/layout/FlexRow';

const citySelectContainer = {
  paddingY: 'padding_12',
  paddingX: 'padding_8',
};

type TFilterToolbarProps = {
  children?: ReactNode;
};

const FilterToolbarItem = ({ children }: TFilterToolbarProps) => {
  return <FlexRow sx={citySelectContainer}>{children}</FlexRow>;
};

export default FilterToolbarItem;
